export enum EBarElementPosition {
	left = "left",
	middle = "middle",
	right = "right"
}
